import { computed } from 'vue';
import { useQueryV2 } from '@libs/use';
import { BankAccountsQuery } from '@libs/api-reference';

import * as API from '../requests';
import { CASH_QUERY_KEYS } from '../constants';

export default function useGetBrokerBankAccountsQuery() {
  const {
    result,
    execute: getBrokerBankAccounts,
    isPending: isLoadingBrokerBankAccounts,
  } = useQueryV2<BankAccountsQuery>(API.getBrokerBankAccounts, {
    key: CASH_QUERY_KEYS.brokerBankAccount,
  });

  const brokerBankAccounts = computed(() => result.value?.data || []);

  return {
    getBrokerBankAccounts,
    brokerBankAccounts,
    isLoadingBrokerBankAccounts,
  };
}
